<template>
  <v-dialog v-model="value" :max-width="type == 'list' ? 'auto' : 800" persistent :retain-focus="false" 
    :fullscreen="type == 'list' ? true : false">
    <announce-edit :id="id" v-if="type == 'edit'" v-model="value"></announce-edit>
    <announce-archive @edit-message="editMessage" v-if="type == 'list'" v-model="value"></announce-archive>
  </v-dialog>
</template>

<script>
import announceEdit from "./announceEdit.vue";
import announceArchive from "./announceArchive.vue";
export default {
  name: "announceDialog",
  emits: [
    "update:modelValue",
    "update:type",
  ],
  props: {
    modelValue: {
      required: true,
    },
    type: {
      required: true,
    }
  },
  components: {
    announceArchive,
    announceEdit,
  },
  watch: {
    value: function (newVal) {
      if (!newVal) {
        this.id = 0;
      }
    }
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  data() {
    return {
      id: 0
    };
  },
  created() {
  },
  methods: {
    editMessage(id) {
      this.id = id;
      this.$emit("update:type", "edit");
    },
  },
};
</script>
<style lang="scss"></style>
